import { useEffect } from 'react';

export const usePreventReload = (shouldPrevent = true) => {
  useEffect(() => {
    if (!shouldPrevent) return;

    const handleBeforeUnload = (event) => {
      // Standard way to trigger browser default 'Leave Site?' dialog
      event.preventDefault();
      event.returnValue = ''; // Required for legacy browser support
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [shouldPrevent]);
};